import ApplicationModel, { attr } from '../ApplicationModel';
import { type AssistantContentAttributes } from './generated/AssistantContentAttributes';
import { model } from '../modelBuilder';

interface AssistantContent extends AssistantContentAttributes {}

@model
class AssistantContent extends ApplicationModel {
  // Start auto-generated
  static typename: 'AssistantContent' = 'AssistantContent';
  get typename(): 'AssistantContent' {
    return 'AssistantContent';
  }

  static fields = {
    data: attr({ readable: true }),
    actionButton: attr.belongsTo({
      readable: true,
      typename: 'AssistantActionButton',
    }),
    panel: attr.belongsTo({
      readable: true,
      typename: 'AssistantPanelContent',
    }),
    preview: attr.belongsTo({
      readable: true,
      typename: 'AssistantPreviewContent',
    }),
    rejectButton: attr.belongsTo({
      readable: true,
      typename: 'AssistantRejectButton',
    }),
  };
  // End auto-generated
}

export default AssistantContent;
